export default "__VITE_PUBLIC_ASSET__e358e25b__"